import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";
import { formatUtcToLocalDate, formatUtcToLocalTime, } from "@application/common/helpers/date-util";
import { alarmTypeLabel } from "@ui/utils/alarm-type-label";
import { sensorUnit } from "@ui/utils/sensors";
/**
 * The bell next to the name of a new-hardware device (AP-Node or relayed node): red while any alarm is unacknowledged, grey
 * otherwise. The tooltip lists the latest alarm of every sensor.
 */
export const SensorAlarmMarker = ({ alarms }) => {
    const { t } = useTranslation("common");
    const unacknowledged = alarms.some((a) => !a.isAlarmAcknowledged);
    const heading = alarms.length > 1 ? t("common:grid.lastAlarms") : t("common:grid.lastAlarm");
    const content = (React.createElement(Box, { sx: { py: 0.5, maxWidth: 280 } },
        React.createElement(Typography, { variant: "subtitle2", sx: { mb: 0.75, fontWeight: 600 } }, heading),
        alarms.map((a, index) => {
            var _a;
            return (React.createElement(Box, { key: `${a.alarmType}-${(_a = a.sensorType) !== null && _a !== void 0 ? _a : "none"}`, sx: { mb: index === alarms.length - 1 ? 0 : 1 } },
                React.createElement(Typography, { variant: "body2", sx: { fontWeight: 600 } }, alarmTypeLabel(a.alarmType, t, a.sensorType)),
                React.createElement(Typography, { variant: "body2" },
                    t("common:grid.valueAtAlarm"),
                    ":",
                    " ",
                    a.temperature != null && !Number.isNaN(Number(a.temperature))
                        ? `${Number(a.temperature).toFixed(1)}${sensorUnit(a.sensorType)}`
                        : t("common:grid.noTemperatureForAlarm")),
                React.createElement(Typography, { variant: "body2" },
                    t("common:grid.alarmTime"),
                    ": ",
                    formatUtcToLocalDate(a.alarmStartDateTime),
                    " ",
                    formatUtcToLocalTime(a.alarmStartDateTime)),
                React.createElement(Typography, { variant: "body2" },
                    t("common:grid.acknowledgementStatus"),
                    ":",
                    " ",
                    a.isAlarmAcknowledged ? t("common:grid.acknowledged") : t("common:grid.unacknowledged"))));
        })));
    return (React.createElement(Tooltip, { title: content, arrow: true, placement: "top", enterTouchDelay: 0 },
        React.createElement(Box, { component: "span", sx: {
                display: "inline-flex",
                alignItems: "center",
                flexShrink: 0,
                cursor: "default",
                color: unacknowledged ? "error.main" : "text.secondary",
            }, "aria-label": heading },
            React.createElement(Icon, { icon: unacknowledged ? "solar:danger-triangle-bold" : "solar:bell-bold", width: 20, height: 20 }))));
};
